import { mapState } from 'vuex';
import { extend } from 'vee-validate';
import dateTimeHelpers from './DateTimeHelpers';
import DownloadHelperMixin from './DownloadHelperMixin';

extend('validQuantity', {
  params: ['maxCapacity', 'qtyUom'],
  validate: (value, { maxCapacity, qtyUom }) => {
    if (value <= maxCapacity) return true;
    return false;
  },
  message: 'Quantity is greater than the maximum capacity of the selected tank - {maxCapacity} {qtyUom}',
});

extend('validLoadingQuantity', {
  params: ['maxCapacity', 'currentQuantity', 'qtyUom'],
  validate: (value, { maxCapacity, currentQuantity, qtyUom }) => {
    const newQuantity = parseFloat(currentQuantity) + parseFloat(value);
    if (newQuantity <= maxCapacity) return true;
    return false;
  },
  message: 'Loading this quantity will exceed the tanks maximum capacity of {maxCapacity} {qtyUom}',
});

extend('validDeliveryQuantity', {
  params: ['maxCapacity', 'currentQuantity', 'qtyUom'],
  validate: (value, { currentQuantity, qtyUom }) => {
    const val = parseFloat(value);
    const qty = parseFloat(currentQuantity);

    if (val <= qty) return true;
    return false;
  },
  message: 'This amount exceeds the current  quantity remaining in tank',
});

export default {
  mixins: [DownloadHelperMixin],
  data() {
    return {
      selectedTransaction: null,
    };
  },
  computed: {
    ...mapState(['voyageReportsStore', 'bulkTransactionsStore']),
    bulkTransactionTypes() {
      return this.bulkTransactionsStore ? this.bulkTransactionsStore.bulkTransactionTypes : null;
    },
  },
  methods: {
    getCompletedDateTime(transaction) {
      const defaultTime = '00:00';
      const completedTime = transaction.completedTime ?? defaultTime;
      return `${transaction.completedDate}T${completedTime}`;
    },
    getCompletedDateValue(completedDateTimeLt) {
      return dateTimeHelpers.getDateStringFromDateTime(completedDateTimeLt);
    },
    getCompletedTimeValue(completedDateTimeLt) {
      return dateTimeHelpers.getTimeStringFromDateTime(completedDateTimeLt);
    },
    getBulkTransactionUpdateModel(transaction) {
      const completedDateTimeLt = this.getCompletedDateTime(transaction);
      return {
        id: transaction.id,
        completedDateTimeLt,
        transactionType: transaction.transactionType,
        bulk: transaction.bulk,
        quantity: parseFloat(transaction.quantity),
        qtyUom: transaction.qtyUom,
        bulkDeliveryNoteNumber: transaction.bulkDeliveryNoteNumber,
        comments: transaction.comments,
      };
    },
    setSelectedBulkTransactionInputValues() {
      this.selectedTransaction.completedDate = this.getCompletedDateValue(
        this.selectedTransaction.completedDateTimeLt,
      );

      this.selectedTransaction.completedTime = this.getCompletedTimeValue(
        this.selectedTransaction.completedDateTimeLt,
      );

      // Create fake file for vuetify file input component from bulkDeliveryNoteFileName
      const { bulkDeliveryNoteFileName } = this.selectedTransaction;
      if (bulkDeliveryNoteFileName) {
        const fileProperties = { type: 'application/pdf' };
        this.selectedTransaction.bulkDeliveryNoteFile = new File([],
          bulkDeliveryNoteFileName,
          fileProperties);
      }
    },
    downloadBulkDeliveryNoteForItem(transactionId, openInBrowser = false) {
      this.downloadFile('bulkTransactionsStore/getBulkDeliveryNotePdf', transactionId, openInBrowser);
    },
    addBulkDeliveryNoteToTransaction(bulkDeliveryNoteFile, transactionId) {
      const payload = { file: bulkDeliveryNoteFile, bulkTransactionId: transactionId };
      return this.$store.dispatch('bulkTransactionsStore/uploadBulkDeliveryNotePdf', payload);
    },
    onSuccess(message, data) {
      this.$toast.success(message);
    },
    onError(message, data) {
      this.$toast.error(message);
      console.error(message, data);
    },
  },
};
